/* DOMNO. rewards — the state harness.  domno.com/?dp=harness&preview_theme_id=187839807861

   WHY THIS EXISTS
   Every signed-in screen in this portal was, until now, testable only by hand-injecting fake
   markup into a console — slow, invisible to Dom, and it meant nobody but Claude ever saw a
   state before customers did. Dom asked whether Claude artifacts could be used to preview the
   flows instead. They cannot: an artifact has no Shopify session, cannot write to /cart/add.js
   across origins, and cannot intercept the theme's checkout button. So the harness lives HERE,
   inside the real theme, with the real CSS, the real fonts and the real components.

   It renders every state down one page against the portal's own stylesheet, so what you see is
   what a customer would see. Open it on a phone before shipping anything.

   ⚠ IT IS INERT. It never calls the worker, never touches the cart, never grants or spends a
   credit. It paints markup and stops. The only thing it proves is what a screen LOOKS like —
   behaviour still has to be tested on the real cart, which is the point of the two live buttons
   at the bottom.

   ⚠ IT ONLY RUNS ON ?dp=harness. No query string, no harness, no cost to a real customer. */
(function(){
  if (new URLSearchParams(location.search).get('dp') !== 'harness') return;

  var RING = 'https://cdn.shopify.com/s/files/1/0305/7100/4043/files/FlameRing01.jpg?v=1772537748&width=300';
  var GIFT = 'https://domno.com/cdn/shop/files/FREEGIFT.jpg?v=1788959899&width=200';

  function money(v){
    return (typeof window.dpFormat === 'function') ? window.dpFormat(v) : ('£' + v);
  }
  function min(){
    return (typeof window.dpMinSpend === 'function') ? window.dpMinSpend() : '£25';
  }

  /* ---------- the pieces of the real portal, reused verbatim ---------- */
  function box(label, big, body, tone){
    return '<div class="box"><div class="lbl">' + label + '</div>' +
           '<div class="disp big" style="color:' + (tone || 'var(--red)') + '">' + big + '</div>' +
           '<p class="body">' + body + '</p></div>';
  }
  function btn(text, kind){ return '<div class="btn ' + (kind||'hot') + '">' + text + '</div>'; }
  function alert(head, body, kind){
    return '<div class="al ' + (kind||'') + '"><div class="alh">' + head + '</div>' +
           '<p class="body">' + body + '</p></div>';
  }
  function ladder(now){
    var names = ['Ring','Chain','Pendant','Any piece'], h = '<div class="ladder">';
    for (var i=0;i<4;i++){
      var cls = (i+1 < now) ? ' done' : ((i+1 === now) ? ' now' : '');
      h += '<div class="step' + cls + '"><span class="dot"></span>' + names[i] + '</div>';
    }
    return h + '</div>';
  }
  function cartline(warn){
    return '<div class="cl">' +
      '<img src="' + GIFT + '" alt="">' +
      '<div style="flex:1">' +
        '<div style="font-size:10px;font-weight:700">FREE GIFT</div>' +
        '<div style="font-size:9.5px;font-weight:700;margin-top:3px">STARPOINT RING · SILVER · 8: FREE</div>' +
        (warn
          ? '<div style="font-size:9.5px;margin-top:4px;color:#b06a00;font-weight:700">' + warn + ' MORE AND IT’S YOURS</div>'
          : '<div style="font-size:9.5px;margin-top:2px;opacity:.62">MINIMUM SPEND: ' + min() + '</div>') +
        '<div style="font-size:9px;text-decoration:underline;margin-top:6px;opacity:.6">REMOVE</div>' +
      '</div>' +
      '<div style="text-align:right">' +
        '<div style="color:#d81f26;font-weight:700;font-size:10.5px">' + money(0) + '</div>' +
        '<div style="color:#8a8a8a;text-decoration:line-through;font-size:9.5px">' + money(25) + '</div>' +
      '</div></div>';
  }

  /* ---------- every state ---------- */
  function states(){
    var m = min();
    return [
      ['S1','Signed out','opens the portal with no account',
        '<div style="text-align:center;padding:30px 6px">' +
          '<div class="disp" style="font-size:30px;letter-spacing:-.045em">DOMNO.</div>' +
          '<div class="lbl" style="margin:9px 0 18px">Your account · orders · rewards</div>' +
          btn('Sign in','dark') + '</div>'],

      ['S2','Just signed up','the welcome credit is granted on this load',
        box('your rewards','one free ring',
            'pick yours below and it goes in your bag at £0. free on any order over <b>' + m +
            '</b>, one per order, and they don’t expire.') +
        ladder(1) + btn('Choose your free ring')],

      ['S3','Several banked','used none, holding three',
        box('your rewards','three free pieces',
            'pick one below and it goes in your bag at £0, free on any order over <b>' + m +
            '</b>. one per order, and they don’t expire.') +
        ladder(1) + btn('Choose your free ring')],

      ['S4','Picked, qualifying','a piece is in the bag and the order clears the minimum',
        box('in your bag','Starpoint Ring',
            'silver · 8, worth ' + money(25) + '. yours free on this order over <b>' + m +
            '</b>. pick another below to swap it.') +
        btn('Change your pick') +
        '<div class="chosen"><span><b>Starpoint Ring · Silver · 8</b> · <b class="free">FREE</b></span>' +
        '<span class="rm">Remove</span></div>'],

      ['S5','Short of the minimum','picked, but the rest of the cart is under the threshold',
        alert(money(21.01) + ' more and it’s yours…',
              'your free <b>Starpoint Ring</b> comes with any order over <b>' + m +
              '</b>. you’re at <b>' + money(3.99) + '</b>.', 'warn') +
        btn('Keep shopping','ghost')],

      ['S6','Nothing to spend','spent them all and not earned another yet',
        box('your rewards','nothing in here yet',
            'place an order or leave a photo review and one lands here. they don’t expire, ' +
            'so there’s no rush.', 'var(--ink)')],

      ['R1','Photo review, earned','left a photo review and had not claimed before',
        alert('cheers for the photo',
              'that’s <b>a free piece</b> on us for <b>Starpoint Ring</b>. pick yours below and it ' +
              'goes in your bag at £0, free on your next order over <b>' + m + '</b>.')],

      ['R2','Text review, nothing earned','wrote a review with no photo, still has theirs to claim',
        alert('cheers for the review',
              'to get <b>a free piece</b> the review needs <b>a photo</b> of it on. it’s one per ' +
              'account, so yours is still sitting there whenever you want it.', 'warn')],

      ['R3','Photo, already claimed','second photo review, nothing more to give',
        alert('cheers for the photo',
              'you’ve already had your free piece for reviewing, but photos are the ones people ' +
              'actually read, so this one helps.')],

      ['F1','Referral, nothing yet','opens Refer for the first time — NOT BUILT',
        box('bring a mate into the fam','a free piece each',
            'they get one on their first order. you get one when it ships.') +
        '<div class="code">DOM-4K2P</div>' + btn('Copy code','dark')],

      ['F2','Referral paid out','their mate’s first order shipped — NOT BUILT',
        alert('your mate came good',
              'their first order’s shipped, so there’s <b>a free piece</b> in your account. one each.')],

      ['B1','Birthday landed','their birthday week — NOT BUILT',
        alert('happy birthday from all of us 🎂',
              'there’s <b>a free piece</b> in your account and no minimum on this one.')],

      ['W1','Refunded order takes it back','an order that earned a credit was refunded — NOT BUILT',
        alert('one free piece removed',
              'order D86402 was refunded, so the free piece it earned has come off your account. ' +
              'nothing else has changed.', 'bad')],

      ['W2','Swap failed','paid, but the swap could not run. order held so it cannot ship wrong',
        alert('we’re sorting your free piece',
              'something went wrong adding your <b>Starpoint Ring</b> to order D86402. we’ve paused ' +
              'the order and we’re on it — nothing needed from you.', 'warn')],

      ['W3','Cancelled before dispatch','cancelled, so the piece goes back — NOT BUILT',
        alert('your free piece is back',
              'order D86402 was cancelled, so the piece you picked is back in your account.')],

      ['W4','Rewards cannot load','the worker is unreachable — NOT BUILT',
        box('your rewards','can’t load this right now',
            'your pieces are safe, we just can’t reach them this second. give it a minute.',
            'var(--ink)')],

      ['C1','Cart line, qualifying','what the free piece looks like in the cart', cartline(null)],
      ['C2','Cart line, short','same line, under the minimum', cartline(money(21.01))]
    ];
  }

  function build(){
    var wrap = document.createElement('div');
    wrap.id = 'dp-harness';
    var css =
      '#dp-harness{position:fixed;inset:0;z-index:2147483646;background:#f2f5f8;overflow:auto;' +
        'font-family:Helvetica,"Helvetica Neue",Arial,sans-serif;padding:18px}' +
      '#dp-harness .hd{max-width:1100px;margin:0 auto 16px;background:#fff;border:1px solid #dbe3ec;' +
        'border-radius:16px;padding:18px 20px;color:#1c2b39}' +
      '#dp-harness .hd h1{margin:0 0 4px;font-size:19px}' +
      '#dp-harness .hd p{margin:0;color:#6b7c8f;font-size:13px}' +
      '#dp-harness .grid{max-width:1100px;margin:0 auto;display:grid;gap:16px;' +
        'grid-template-columns:repeat(auto-fill,minmax(300px,1fr));align-items:start}' +
      '#dp-harness .card{background:#fff;border:1px solid #dbe3ec;border-radius:16px;overflow:hidden}' +
      '#dp-harness .cap{padding:12px 14px;border-bottom:1px solid #dbe3ec;color:#1c2b39}' +
      '#dp-harness .cap .id{font-size:10px;letter-spacing:.12em;color:#6b7c8f;text-transform:uppercase}' +
      '#dp-harness .cap .nm{font-weight:700;font-size:14px;margin-top:2px}' +
      '#dp-harness .cap .wh{color:#6b7c8f;font-size:12.5px;margin-top:4px}' +
      '#dp-harness .scr{padding:14px;background:#fff}' +
      '#dp-harness .x{position:fixed;top:12px;right:14px;z-index:2;background:#111;color:#fff;' +
        'border:0;padding:10px 15px;font-weight:700;font-size:12px;cursor:pointer}' +
      /* the portal's own tokens, so these render exactly as the real screens do */
      '#dp-harness .p{--dim:#6b6b6f;--line:#e4e4e4;--panel:#f6f6f6;--red:#ff0000;--ink:#111;' +
        '--disp:\'Montserrat\',Helvetica,Arial,sans-serif;color:#111;text-transform:uppercase}' +
      '#dp-harness .p .disp{font-family:var(--disp);font-weight:900;font-style:italic}' +
      '#dp-harness .p .box{background:var(--panel);border:1px solid var(--line);padding:15px 13px;' +
        'text-align:center;margin-bottom:11px}' +
      '#dp-harness .p .lbl{color:var(--dim);font-size:9px;letter-spacing:.17em}' +
      '#dp-harness .p .big{font-size:23px;margin:5px 0 7px;line-height:1.05;word-break:break-word}' +
      '#dp-harness .p .body{font-size:11px;line-height:1.55;text-transform:none;margin:0}' +
      '#dp-harness .p .btn{display:block;width:100%;padding:12px;border:0;font-weight:700;' +
        'font-size:10.5px;letter-spacing:.07em;text-align:center;margin-top:11px}' +
      '#dp-harness .p .btn.hot{background:var(--red);color:#fff}' +
      '#dp-harness .p .btn.dark{background:#111;color:#fff}' +
      '#dp-harness .p .btn.ghost{background:#fff;border:1px solid var(--line);color:#111}' +
      '#dp-harness .p .ladder{display:flex;justify-content:space-between;position:relative;margin:14px 2px 16px}' +
      '#dp-harness .p .ladder:before{content:"";position:absolute;top:7px;left:11%;right:11%;height:2px;background:var(--line)}' +
      '#dp-harness .p .step{position:relative;text-align:center;flex:1;font-size:8px;color:var(--dim);' +
        'font-family:var(--disp);font-weight:900;font-style:italic}' +
      '#dp-harness .p .step .dot{width:15px;height:15px;border-radius:50%;background:#fff;' +
        'border:2px solid var(--line);display:block;margin:0 auto 5px}' +
      '#dp-harness .p .step.done{color:#111}#dp-harness .p .step.done .dot{background:#111;border-color:#111}' +
      '#dp-harness .p .step.now{color:var(--red)}#dp-harness .p .step.now .dot{background:var(--red);border-color:var(--red)}' +
      '#dp-harness .p .al{border:1px solid #111;padding:11px 12px;margin-bottom:11px;background:#fff}' +
      '#dp-harness .p .al.warn{border-color:#b06a00;background:#fff8ee}' +
      '#dp-harness .p .al.bad{border-color:#c0271a;background:#fdf0ee}' +
      '#dp-harness .p .alh{font-family:var(--disp);font-weight:900;font-style:italic;font-size:11px;margin-bottom:4px}' +
      '#dp-harness .p .chosen{border:1px solid var(--line);padding:10px 11px;font-size:10px;' +
        'display:flex;justify-content:space-between;margin-top:9px}' +
      '#dp-harness .p .chosen b{color:var(--red)}#dp-harness .p .chosen .rm{opacity:.6;text-decoration:underline}' +
      '#dp-harness .p .code{font-family:ui-monospace,Menlo,monospace;font-size:17px;font-weight:800;' +
        'letter-spacing:3px;background:#fff;border:1px dashed #cfcfcf;padding:11px;text-align:center;margin:8px 0}' +
      '#dp-harness .p .cl{display:flex;gap:11px;align-items:flex-start;padding:10px 0;text-transform:uppercase}' +
      '#dp-harness .p .cl img{width:54px;height:66px;object-fit:cover;flex:0 0 54px;background:#f5f5f5}';

    var s = document.createElement('style'); s.textContent = css;
    document.head.appendChild(s);

    var cards = states().map(function(st){
      return '<div class="card"><div class="cap"><div class="id">' + st[0] + '</div>' +
             '<div class="nm">' + st[1] + '</div><div class="wh">' + st[2] + '</div></div>' +
             '<div class="scr"><div class="p">' + st[3] + '</div></div></div>';
    }).join('');

    wrap.innerHTML =
      '<button class="x" onclick="document.getElementById(\'dp-harness\').remove()">Close</button>' +
      '<div class="hd"><h1>Rewards — every state</h1>' +
      '<p>Real portal CSS, real fonts, real components. Inert: nothing here calls the worker or ' +
      'touches your cart. Market: <b>' + ((window.Shopify && window.Shopify.country) || '?') +
      '</b> · minimum <b>' + min() + '</b>.</p></div>' +
      '<div class="grid">' + cards + '</div>';

    document.body.appendChild(wrap);
    document.documentElement.style.overflow = 'hidden';
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
